import { FilterOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React from 'react';
import { GrPowerReset } from 'react-icons/gr';
import { IoChevronBack } from 'react-icons/io5';

const AlarmManagementHistoryHeader = ({
  onBack,
  state,
  setState,
  handleResetForm,
}) => {
  return (
    <div>
      <div className="flex items-center justify-between">
        <h1 className="font-medium md:font-bold text-xl relative">
          Alarm Management Historys
        </h1>
        <div className="grid grid-cols-2 md:flex md:flex-row gap-2 justify-end items-center">
          <Tooltip placement="top" title="Back" color="#6E6FF7">
            <Button
              onClick={onBack}
              // icon={<IoChevronBack className="text-base" />}
              className=" flex justify-center items-center h-8 text-xs text-[#6E6FF7] bg-gray-50"
            >
              <IoChevronBack className="text-base" />
              {/* <span className=" md:text-xs">Back</span> */}
            </Button>
          </Tooltip>
          <Tooltip placement="top" title="Reset" color="#e98181">
            <Button
              // icon={<GrPowerReset />}
              // disabled={state.submit == false ? true : false}
              className=" flex justify-center items-center  h-8 text-xs text-red-400  bg-gray-50"
              onClick={handleResetForm}
            >
              <GrPowerReset size={16} />
              {/* <span className="md:text-xs">Reset</span> */}
            </Button>
          </Tooltip>

          <Tooltip placement="top" title="Filter" color="#6E6FF7">
            <Button
              onClick={() => setState({ ...state, showFilterModal: true })}
              // icon={<FilterOutlined className="" />}
              className="flex items-center  h-8 text-[#6E6FF7] bg-gray-50"
            >
              <FilterOutlined className="" />
              <span className=" md:text-xs">Filter</span>
            </Button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default AlarmManagementHistoryHeader;
